export const translationKeys = {
  id: 'id',
  key: 'key',
  name: 'name',
  value: 'value',
};
